/**
 * dom-autoscroller (Form.io / drag-and-drop) does `require('animation-frame-polyfill')` and
 * calls `animationFramePolyfill.cancelAnimationFrame(...)`. Webpack 5 can expose this package
 * with APIs nested under `default`, so those properties are missing on the namespace object.
 * Pin the official CommonJS build so `cancelAnimationFrame` / `requestAnimationFrame` stay on
 * the top-level export (see animation-frame-polyfill `dist/animation-frame-polyfill.cjs`).
 *
 * Relative path avoids `require('animation-frame-polyfill')` recursion into this same alias.
 */
// eslint-disable-next-line sonarjs/no-internal-api-use -- must load published `main` CJS file by path (see comment above)
const raw = require('../../node_modules/animation-frame-polyfill/dist/animation-frame-polyfill.cjs');

/**
 * @param {unknown} m module namespace from require()
 * @returns {{ requestAnimationFrame: Function, cancelAnimationFrame: Function }}
 */
function unwrapOrFallback(m) {
  const isPair = (x) =>
    x &&
    typeof x === 'object' &&
    typeof x.cancelAnimationFrame === 'function' &&
    typeof x.requestAnimationFrame === 'function';

  if (isPair(m)) {
    return m;
  }
  if (m && typeof m === 'object' && 'default' in m && isPair(m.default)) {
    return m.default;
  }
  if (typeof window !== 'undefined' && isPair(window)) {
    return {
      requestAnimationFrame: window.requestAnimationFrame.bind(window),
      cancelAnimationFrame: window.cancelAnimationFrame.bind(window),
    };
  }
  return /** @type {{ requestAnimationFrame: Function, cancelAnimationFrame: Function }} */ (m);
}

module.exports = unwrapOrFallback(raw);
